import { render, staticRenderFns } from "./ModalEditPaymentType.vue?vue&type=template&id=233bf1ed&"
import script from "./ModalEditPaymentType.vue?vue&type=script&lang=js&"
export * from "./ModalEditPaymentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports